import React, { Component } from 'react';
import RDP_CONFIG from '../../config';
import {UserService} from '../../services/user';
import './element-audio.css';

export default class ElementAudio extends Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(content) {
    this.props.onChange(content);
  }

  getAudioUrl(audio) {
    var accessToken = UserService.getUser().access_token;
    if (audio !== "https://pocs.digitalpages.com.br/rdpcomposer/media/audio-1/audio-1.mp3") {
      audio += "&access_token=" + accessToken + "&project_key=" + RDP_CONFIG.projectKey;
    };
    return audio;
  }

  getSubtitlesUrl(subtitles) {
    if (!subtitles) return null;
    var accessToken = UserService.getUser().access_token;
    if (subtitles.indexOf('?') > -1) {
      return subtitles + "&access_token=" + accessToken + "&project_key=" + RDP_CONFIG.projectKey;
    }
    return subtitles + "?access_token=" + accessToken + "&project_key=" + RDP_CONFIG.projectKey;
  }

  render() {
    let { headerActionsTemplate, footerActionsTemplate, content } = this.props;
    var audioStyle = {
      background: content.background_color,
      paddingTop: content.padding_top + "px",
      paddingBottom: content.padding_bottom + "px"
    }

    return (<div className={this.props.className} style={audioStyle}>
      {headerActionsTemplate}
      <audio controls src={this.getAudioUrl(content.audio)} crossOrigin="anonymous" aria-describedby={content.transcript ? `${content.id}-transcript` : undefined}>
      </audio>
      {content.transcript && (
        <div>
          <div className="rdp-audio-transcript" style={{ marginTop: '10px', padding: '10px', fontSize: '14px', lineHeight: '1.6' }}>
            <details>
              <summary style={{ cursor: 'pointer', fontWeight: 'bold' }}>Transcrição</summary>
              <p style={{ marginTop: '10px', whiteSpace: 'pre-wrap' }}>{content.transcript}</p>
            </details>
          </div>
          <div id={`${content.id}-transcript`} className="sr-only" style={{ position: 'absolute', left: '-10000px', width: '1px', height: '1px', overflow: 'hidden' }}>
            Transcrição do áudio: {content.transcript}
          </div>
        </div>
      )}
      {footerActionsTemplate}
    </div>)
  }
}
